var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._t("name",function(){return [_vm._v("Name")]})],2),_c('span',{staticClass:"badge bg-danger"},[_vm._t("count",function(){return [_vm._v("0")]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }